import axios from "../axios"

export const GetAllUsers = async () =>{
    try{
        const response = await axios.get("/api/User/GetAllUsers");
        return response.data;
    }catch(error){
        if(error.response){
            console.log("API Error:", error.response.data);
            throw new Error(error.response.data.message || "Cannot Get Users");
        }
        else{
            throw new Error("Network error or server unreachable");
        }
    }
} 

export const AccessedRestrictedProjects = async (uid) => {
  try {
    const response = await axios.get(`/api/User/${uid}/projects`);
    return response.data; 
  } catch (error) {
    if (error.response) {
      console.log("API Error:", error.response);
      throw new Error(error.response.data?.message || "Cannot Get Projects");
    } else {
      throw new Error("Network error or server unreachable");
    }
  }
};

export const AssignProject = async (userUID, appUID, createdBy = 0) =>{
    const payload = {
        userUID,
        appUID,
        createdBy
    }
    try{
        const response = await axios.post("/api/User/AssignProject", payload);
        return response.data;
    }catch(error){
        if(error.response){
            console.log("API Error:", error.response.data);
            throw new Error(error.response.data.message || "Cannot Get Users");
        }
        else{
            throw new Error("Network error or server unreachable");
        }
    }
}

export const RestrictedProject = async (userUID, appUID, createdBy = 0) =>{
    const payload = {
        userUID,
        appUID,
        createdBy
    }
    try{
        const response = await axios.post("/api/User/RemoveProject", payload);
        return response.data;
    }catch(error){
        if(error.response){
            console.log("API Error:", error.response.data);
            throw new Error(error.response.data.message || "Cannot Get Users");
        }
        else{
            throw new Error("Network error or server unreachable");
        }
    }
}
